/**
 * Pagination constant - number of attendees to load per page/batch
 */
export const ATTENDEES_PER_PAGE = 50;
